import { render, staticRenderFns } from "./novice-guide.vue?vue&type=template&id=f360364e&scoped=true&"
import script from "./novice-guide.vue?vue&type=script&lang=js&"
export * from "./novice-guide.vue?vue&type=script&lang=js&"
import style0 from "./novice-guide.vue?vue&type=style&index=0&id=f360364e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f360364e",
  null
  
)

export default component.exports